<template>
  <div class="fps-img-wrap">
    <div class="fps-img-box" :style="imageList.length && 'cursor: zoom-in;'" @click.stop="viewDetailAlbumInPc">
      <div
        class="fps-img-self"
        :style="{
          borderRadius: borderRadius,
          backgroundImage: `url(${src})`,
          backgroundPosition: position,
          backgroundSize: size,
        }"
      />
    </div>
    <span
      class="fps-img-place"
      :style="{
        'border-radius': borderRadius,
        backgroundColor: color,
      }"
    />
    <el-dialog
      :visible.sync="showFullScreenImage"
      custom-class="dialog-clear-style"
      :show-close="false"
      :modal="false"
      append-to-body
    >
      <div class="full-screen" @click="showFullScreenImage = false">
        <div v-if="imageList && imageList.length" class="custom-swiper">
          <el-carousel
            ref="ranks"
            class="ranks-slide"
            height="100vh"
            :interval="0"
            trigger="click"
            arrow="never"
            indicator-position="none"
            :initial-index="defaultIndex"
            :loop="imageList.length > 1"
          >
            <el-carousel-item
              v-for="(image, index) in imageList"
              :key="index"
              class="ranks-slide-card"
            >
              <img
                class="game-image"
                :src="image"
              >
            </el-carousel-item>
          </el-carousel>
          <div
            v-show="imageList.length > 1"
            class="custom-arrow custom-arrow-left"
            @click.stop="swipeChange('prev')"
          >
            <fps-icon type="arrow-left" size="24" />
          </div>
          <div
            v-show="imageList.length > 1"
            class="custom-arrow custom-arrow-right"
            @click.stop="swipeChange('next')"
          >
            <fps-icon type="arrow-right" size="24" />
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  props: {
    src: String,
    borderRadius: {
      type: String,
      default: '0',
    },
    imageList: {
      type: Array,
      default: () => [],
    },
    defaultIndex: {
      type: Number,
      default: 0,
    },
    position: {
      type: String,
      default: 'center center',
    },
    color: {
      type: String,
      default: '#e8e8e8',
    },
    size: {
      type: String,
      default: 'cover',
    },
  },
  data() {
    return {
      // loaded: false,
      showFullScreenImage: false,
    }
  },
  watch: {
    defaultIndex(index) {
      this.$nextTick(() => {
        const $swipe = this.$refs.ranks
        $swipe && $swipe.setActiveItem(index)
      })
    },
    showFullScreenImage(show) {
      if (show) {
        document.addEventListener('keydown', this.keyDown)
        document.body.style.overflow = 'hidden'
      } else {
        document.removeEventListener('keydown', this.keyDown)
        document.body.style.overflow = 'auto'
      }
    },
  },
  methods: {
    keyDown(e) {
      if (this.imageList.length < 2) return 
      if (e.keyCode === 39) {
        this.swipeChange('next')
      } else if (e.keyCode === 37) {
        this.swipeChange('prev')
      }
    },
    // 切换轮播
    swipeChange(method) {
      const $swipe = this.$refs.ranks
      if (!$swipe) return
      $swipe[method]()
    },
    viewDetailAlbumInPc() {
      if (!this.imageList.length || this.defaultIndex >= this.imageList.length) return
      this.showFullScreenImage = true
    },
  },
}
</script>

<style lang="scss" scoped>
  .game-image {
    max-width: 100%;
    max-height: 100%;
  }
  .fps-img-box {
    cursor: zoom-in;
  }
  .fps-img {
    &-wrap {
      position: relative;
      width: 100%;
      height: 100%;
    }
    &-box, &-place {
      position: absolute;
      top: 0;
      left: 0;
    }
    &-box {
      @include flex();
      font-size: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    &-place {
      display: inline-block;
      width: 100%;
      height: 100%;
      background: #e8e8e8;
    }
    &-self {
      z-index: 1;
      opacity: 1;
      transition: opacity .4s;
      width: 100%;
      height: 100%;
      background: no-repeat center center / cover;
    }
  }
  .full-screen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    background: rgba(0, 0, 0, .9);
    cursor: zoom-out;

    .custom-swiper {
      width: 100vw;
      position: relative;
      .ranks-slide-card {
        @include flex;
      }
      .one-game {
        & > div {
          width: 100%;
          height: 100%;
          &.selected-photo {
            position: relative;
            &::after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              border-radius: 4px;
              border: 2px solid #E8BD0C;
            }
          }
        }
      }
      .custom-arrow {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        background: rgba(255, 255, 255, .2);
        @include flex;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) !important;
        opacity: 1;
      }
      .custom-arrow-right {
        right: 16px;
      }
      .custom-arrow-left {
        left: 16px;
      }
    }
  }
</style>
